var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2271 0C24.8658 0 83.5384 0 84.6029 0C87.5408 0 90.3935 0.468359 93.1611 1.44766C97.1634 2.89531 100.783 5.45 103.508 8.77109C106.275 12.0922 108.106 16.1797 108.745 20.4375C109 22.0129 109.043 23.5883 109.043 25.1637C109.043 26.6113 109.043 77.6199 109.043 79.9191C109.043 81.2816 109.043 82.6867 109.043 84.0492C109.043 85.9227 108.958 87.8387 108.574 89.6695C107.723 93.8848 105.722 97.8445 102.826 101.038C99.9736 104.231 96.2267 106.616 92.1818 107.893C89.7122 108.659 87.1576 109 84.5603 109C83.4107 109 24.0568 109 23.1626 108.957C18.8197 108.745 14.5193 107.339 10.9001 104.912C7.36616 102.528 4.47085 99.207 2.59741 95.375C0.979439 92.0965 0.170455 88.4348 0.170455 84.773C0.170455 83.9215 0.170455 25.0785 0.170455 24.227C0.0852983 20.6078 0.851705 17.0313 2.4271 13.7953C4.25795 9.96328 7.11069 6.59961 10.6447 4.21523C14.2638 1.7457 18.5216 0.298047 22.8646 0.0851563C23.2904 0 23.7587 0 24.2271 0Z",
    fill: "url(#paint0_linear_1399_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9688 89.1586C91.5855 88.5625 91.1598 87.9664 90.6914 87.4129C89.627 86.1355 88.3922 85.0285 87.0297 84.0918C85.3266 82.9422 83.3254 82.2184 81.2816 82.1332C79.834 82.048 78.3863 82.3035 77.0238 82.8145C75.6613 83.2828 74.3414 83.9641 73.0641 84.6453C71.5738 85.4117 70.0836 86.1781 68.5082 86.8168C66.6348 87.5832 64.6762 88.1793 62.675 88.6051C60.1629 89.0734 57.6082 89.2438 55.0961 89.2012C50.5402 89.116 45.9844 88.4348 41.6414 87.1574C37.8094 86.0078 34.1477 84.4324 30.6988 82.4313C27.6758 80.6855 24.8656 78.6844 22.2258 76.4277C20.0543 74.5543 18.0531 72.5531 16.1797 70.4242C14.9023 68.934 13.6676 67.3586 12.518 65.7406C12.0496 65.102 11.6238 64.4207 11.2406 63.7395L0 51.6047V24.1418C0 10.8148 10.7723 0 24.0992 0H45.6012L61.5254 16.1797C97.4613 40.6195 85.8375 67.5715 85.8375 67.5715C85.8375 67.5715 96.0563 79.0676 91.9688 89.1586Z",
    fill: "url(#paint1_linear_1399_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6106 16.1797C97.5466 40.6195 85.9228 67.5715 85.9228 67.5715C85.9228 67.5715 96.1415 79.1102 92.0114 89.2012C92.0114 89.2012 87.7962 82.1332 80.7282 82.1332C73.9157 82.1332 69.9134 89.2012 56.2032 89.2012C25.6747 89.2012 11.2407 63.6969 11.2407 63.6969C38.7462 81.7926 57.5231 68.9766 57.5231 68.9766C45.1329 61.7809 18.7771 27.3777 18.7771 27.3777C41.7267 46.9211 51.6474 52.073 51.6474 52.073C45.729 47.1766 29.1235 23.2477 29.1235 23.2477C42.4079 36.7023 68.8064 55.4793 68.8064 55.4793C76.3001 34.7012 61.6106 16.1797 61.6106 16.1797Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1399_104",
    x1: 64.8424,
    y1: -3.88943,
    x2: 44.2487,
    y2: 112.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1399_104",
    x1: 55.612,
    y1: 1.76116,
    x2: 40.5399,
    y2: 87.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.ef5ad1088d04e060e7b9fd8bc2e09752.svg";
export { ForwardRef as ReactComponent };